const ListingDetailsToggle = ({ label, value, onChange, id }) => {
  const active = value === 'yes';
  return (
    <div className="listing-details-toggle-row">
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={active}
        aria-label={label}
        className={`listing-details-toggle${active ? ' listing-details-toggle--active' : ''}`}
        onClick={() => onChange(active ? 'no' : 'yes')}
      >
        <span className="listing-details-toggle__knob" aria-hidden="true" />
      </button>
      <span className="listing-details-toggle-row__label">{label}</span>
    </div>
  );
};

export default ListingDetailsToggle;
